import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Seo from "@/components/site/Seo";
import { API } from "@/lib/api";
import { track } from "@/lib/analytics";

export default function PaymentResult({ ok }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(ok ? "checking" : "cancelled");
  const [data, setData] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    if (!ok || !sessionId) return;
    let stop = false;
    const poll = async () => {
      try {
        const r = await fetch(`${API}/payments/status/${sessionId}`);
        const d = await r.json();
        if (stop) return;
        if (d.payment_status === "paid") { setData(d); setState("paid"); track("purchase_paid", { order: d.order_number }); return; }
        if (["failed", "expired"].includes(d.payment_status)) { setState("failed"); return; }
      } catch (e) {}
      tries.current += 1;
      if (tries.current < 12) setTimeout(poll, 2000); else setState("failed");
    };
    poll();
    return () => { stop = true; };
  }, [ok, sessionId]);

  return (
    <SiteLayout>
      <Seo title="Payment — The Sourcing Atlas" description="Payment status" path="/payment" noindex />
      <div className="simplepage" data-testid="payment-result">
        {state === "checking" && (<><h1>Confirming your payment…</h1><p style={{ color: "var(--grey)" }}>Please wait a moment — this can take a few seconds.</p></>)}
        {state === "paid" && (
          <>
            <h1 data-testid="payment-success">✓ Payment received — order {data?.order_number}</h1>
            <p style={{ color: "var(--grey)" }}>Your downloads are below and have also been emailed. Each link works for 30 days.</p>
            <div style={{ display: "grid", gap: 10, marginTop: 16 }}>
              {(data?.downloads || []).map((l) => (
                <a key={l.slug} href={l.url} className="btn btn-line" data-testid={`paid-dl-${l.slug}`} style={{ textAlign: "left", padding: "11px 15px" }}>⬇ {l.title}</a>
              ))}
            </div>
            <p style={{ marginTop: 16 }}><Link className="btn btn-navy" to="/guides/my-library">Go to my library</Link></p>
          </>
        )}
        {state === "cancelled" && (<><h1>Payment cancelled</h1><p style={{ color: "var(--grey)" }}>No charge was made. <Link to="/guides" style={{ color: "var(--navy)", fontWeight: 700 }}>Back to guides →</Link></p></>)}
        {state === "failed" && (<><h1>We couldn't confirm your payment</h1><p style={{ color: "var(--grey)" }}>If you were charged, contact us and we'll sort it out right away. <Link to="/guides" style={{ color: "var(--navy)", fontWeight: 700 }}>Back to guides →</Link></p></>)}
      </div>
    </SiteLayout>
  );
}
